
export const host = "https://pingpoint-backend.onrender.com";
// export const host = "http://localhost:5000";
